import React from "react";
import styled from "styled-components";
import LineChart from "./LineChart";
const Wrapper = styled.div`
   box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06);
   border-radius: 10px;
   height: 100%;
   width: 100%;
   h5 span {
      margin-right: 4px;
   }
`;

const ChartCard = ({ numbers, date, title, color, bgColor, pointColor }) => {
   return (
      <Wrapper>
         <div className="flex flex-col p-4 md:p-6 h-full">
            <div className="flex flex-row justify-between pb-4 md:pb-6">
               <h5 className="text-sm font-bold flex-1">{title}</h5>
            </div>
            <div className="flex-1 min-h-0 relative">
               <LineChart numbers={numbers} date={date} color={color} bgColor={bgColor} pointColor={pointColor} title={title} />
            </div>
         </div>
      </Wrapper>
   );
};

export default ChartCard;
